










































































import gql from 'graphql-tag'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import AppFormCard from '@/components/AppFormCard.vue'
import AppTitleBar from '@/components/AppTitleBar.vue'
import AppTextInput from '@/components/AppTextInput.vue'
import FeedItem from '@/components/FeedItem.vue'
import { ITEM_TILE_FRAGMENT } from '@/gql/item'

@Component({
  components: {
    AppFormCard,
    AppTitleBar,
    AppTextInput,
    FeedItem
  }
})
export default class extends Vue {
  @Prop(Object) readonly seller: object | undefined
  @Prop(String) readonly orderId: string | undefined
  @Prop(Array) readonly itemIds!: string[]
  @Prop(Array) readonly itemIdsRecomm!: string[]
  @Prop(File) readonly file!: File
  @Prop(String) readonly title!: string
  @Prop(String) readonly text!: string
  @Prop(Object) readonly comments!: { [key: string]: string }

  feedItems: object[] = []
  feedItemsRecomm: object[] = []
  isAddItemTipActive = false

  mounted () {
    this.isAddItemTipActive = !localStorage.getItem('isAddItemTipDismissed')
  }

  onClickAddItemTip () {
    localStorage.setItem('isAddItemTipDismissed', 'true')
    this.isAddItemTipActive = false
  }

  get videoSrc () {
    return URL.createObjectURL(this.file)
  }

  async onChangeFile (e: any) {
    const file = e.target.files[0]
    if (file) {
      this.$emit('update:file', file)
    }
  }

  async getFeedItemsByItemIds (itemIds: string[]) {
    return await Promise.all(itemIds.map(async itemId => {
      const { data: { item } } = await this.$apollo.query<{ item: { id: string } }>({
        query: gql`query ($itemId: ID!) {
          item(itemId: $itemId) {
            ...ItemTileFragment
          }
        }
        ${ITEM_TILE_FRAGMENT}`,
        variables: { itemId }
      })
      return { item, comment: this.comments[item.id] }
    }))
  }

  @Watch('itemIds')
  async onItemIdsChanged (itemIds: string[]) {
    this.feedItems = await this.getFeedItemsByItemIds(itemIds)
  }

  @Watch('itemIdsRecomm')
  async onItemIdsRecommChanged (itemIds: string[]) {
    this.feedItemsRecomm = await this.getFeedItemsByItemIds(itemIds)
  }

  get enabledSubmit () {
    return this.file && this.title && this.text && this.text.length <= 1000
  }
}
